import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { UniversalValidators } from 'ngx-validators';
import { StableOrganisationDTO } from '../../../../models/stableOrganisation.model';
import { DialogService } from '../../../../services/dialog.service';
import { StableOrganisationService } from '../../../../services/stableOrganisation.service';
import { UtilityService } from '../../../../services/utility.service';
@Component({
  selector: 'app-add-stable-organisation',
  templateUrl: './add-stable-organisation.component.html',
  styleUrls: ['./add-stable-organisation.component.scss']
})
export class AddStableOrganisationComponent implements OnInit {

  @Input("stableOrganisation") stableOrganisation : StableOrganisationDTO;
  @Input("showClose")showClose : boolean;
  @Input("showSave")showSave : boolean;
  @Input("stableOrganisationModalTitle")stableOrganisationModalTitle : string;
  @Output("savedStableOrganisation") savedStableOrganisation : EventEmitter<StableOrganisationDTO> = new EventEmitter<StableOrganisationDTO>();
  @Output("stableOrganisationFormCreated") stableOrganisationFormCreated : EventEmitter<UntypedFormGroup> = new EventEmitter<UntypedFormGroup>();
  stableOrganisationForm : UntypedFormGroup;
  utilityService = UtilityService;


  constructor(private formBuilder : UntypedFormBuilder,
              private stableOrganisationService : StableOrganisationService) { }

  ngOnInit(): void {
    this.createStableOrganisationForm();
    this.stableOrganisationFormCreated.emit(this.stableOrganisationForm);
  }

  createStableOrganisationForm(){
    this.stableOrganisationForm = this.formBuilder.group({
      nic: [this.stableOrganisation.FR_NIC, Validators.compose([
        UniversalValidators.minLength(5),
        UniversalValidators.maxLength(5)
      ])],
      complementAddress: [this.stableOrganisation.FR_ComplementAddress],
      address: [this.stableOrganisation.Address],
      streetNumber : [this.stableOrganisation.StreetNumber],
      postalCode : [this.stableOrganisation.PostalCode, Validators.compose([
        UniversalValidators.minLength(5),
        UniversalValidators.maxLength(10)
      ])],
      city : [this.stableOrganisation.City],
      province : [this.stableOrganisation.Province, Validators.compose([
        UniversalValidators.minLength(2),
        UniversalValidators.maxLength(2)
      ])],
      country : [this.stableOrganisation.Nation, null],
      FR_CountrySubentity : [this.stableOrganisation.FR_CountrySubentity]
    });
  }

  closeStableOrganisationModal(){
    this.savedStableOrganisation.emit(null);
  }

  saveStableOrganisation(){

    this.savedStableOrganisation.emit(this.stableOrganisation);
  //   this.stableOrganisationService.save(this.stableOrganisation).then(res => {
  //     this.savedStableOrganisation.emit(true);
  //   }).catch(err => {
  //     DialogService.Error(err.message);
  //   });
  // }
  }

}
